var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2412 37.5H7.75875C5.54438 37.5 3.75 35.7056 3.75 33.4912V11.5088C3.75 9.29438 5.54438 7.5 7.75875 7.5H37.2412C39.4556 7.5 41.25 9.29438 41.25 11.5088V33.4912C41.25 35.7056 39.4556 37.5 37.2412 37.5Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6538 16.875C24.872 16.8769 24.1332 17.145 23.5445 17.61C22.9463 18.0825 22.0538 18.0825 21.4557 17.61C20.867 17.145 20.1263 16.875 19.3407 16.875C17.4563 16.875 15.9282 18.7537 15.9282 20.6419C15.9282 24.7687 21.6245 28.125 22.5001 28.125C23.3757 28.125 29.072 24.7687 29.072 20.6419C29.072 18.7537 27.542 16.875 25.6538 16.875Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5749 35.7373L27.7124 24.2061",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3436 24.3L4.6123 35.9626",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8751 9.84375L28.8188 19.275",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3124 19.0124L4.18115 9.7312",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationEnvelope);
export default __webpack_public_path__ + "static/media/navigation-envelope.7602d04d.svg";
export { ForwardRef as ReactComponent };